import React from 'react';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';
import logob from '../images/logob.webp';

export default function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-column">
          <h4 className='text-[#DBAC5B]'>Ubicación</h4>
          <p>Oficina Principal:</p>
          
          <p>Av. Pedro Nolasco Videla 520, Coquimbo, Chile</p>
          <img 
      src={logob}
      alt="Funeraria Coquimbo"
      className="logo-img h-24  md:h-24"
    />      
        </div>
        
        <div className="footer-column">
          <h4 className='text-[#DBAC5B]'>Información de Contacto</h4>
          <p>Teléfonos:</p>
          <p>+56 9 8322 1037 (Movil)</p>
          <div className='mb-4'></div>

          <p>Correo Electrónico:</p>
          <p> rojasllewellynltda@gmail.com</p>
          <div className='mb-4'></div>
          <p>Horario de Atención:</p>
          <p>Atendemos las 24 Horas</p>
          
        </div>
        
        <div className="footer-column">
          <h4 className='text-[#DBAC5B]'>Nuestras Redes Sociales</h4>
          <div className="footer-social mb-2">
           
            <a href="https://www.instagram.com/funerariacoquimbo/" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://wa.me/+56983221037" target="_blank" rel="noopener noreferrer ">
              <FaWhatsapp />
            </a>
          </div>
          <p><a href="https://www.instagram.com/funerariacoquimbo/">Instagram:</a></p>
          <p className='pb-2'><a href="https://www.instagram.com/funerariacoquimbo/">https://www.instagram.com/funerariacoquimbo/</a></p>

          <p><a href="https://wa.me/+56983221037">WhatsApp:</a></p>
          <p><a href="https://wa.me/+56983221037">https://wa.me/+56983221037</a></p>
        </div>
        <div className="footer-column footer-map">
  <h4 className='text-[#DBAC5B]'>Mapa de Ubicación</h4>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3456.4843715900133!2d-71.3389187880811!3d-29.965506774859076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9691c9e976ef5029%3A0xd7d09c4f2f916806!2sFuneraria%20Coquimbo!5e0!3m2!1ses-419!2scl!4v1729628735213!5m2!1ses-419!2scl"  width="100%"
    height="200" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
</div>

      </div>

      <div className="footer-bottom text-[#DBAC5B]">
        <p>© 2026 Funeraria Coquimbo. Todos los derechos reservados.</p>
        <p className="developer-credit">
          <a href="https://www.linkedin.com/in/francisco-javier-carrasco-420935227" target="_blank" rel="noopener noreferrer"> Desarrollado por Francisco Carrasco</a>
        </p>
      </div>
    </footer>
  );
}
